import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import Constant from "./Constant";
import SelectAsync from 'react-select/async';

export default class Person extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            fromAutoComplete: this.isNull(props.FromAutoComplete) ? false : props.FromAutoComplete,
            data: null,
            loading: true,
            tab: 0
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/person/get", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.organizationId = data.global.company.id;
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/person/save", {
            id: this.state.id,
            organizationId: this.state.data.global.company.id,
            form: this.state.data.record,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات شخص با موفقیت ذخیره شد");
                    if (this.state.fromAutoComplete)
                        this.state.caller.setPerson({ value: data.id, label: data.code + "-" + this.state.data.record.name });
                    else
                        this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setGroup(e) {
        if (e.value == -1) {
            this.state.data.record.groupId = this.defaultGuid();
            this.state.data.record.groupName = '';
            this.showComponents({ component: <Constant Type={1} Caller={this} FromAutoComplete={true} /> });
            return;
        }
        this.state.data.record.groupId = e.value;
        this.state.data.record.groupName = e.label;
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="hand close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات شخص" : "افزودن شخص جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <ul className="nav nav-tabs">
                                <li role="presentation" className={this.state.tab === 0 ? "hand active" : "hand"}><a onClick={e => this.setState({ tab: 0 })} data-toggle="tab" target="_self" aria-expanded="false">اطلاعات شخص</a></li>
                                <li role="presentation" className={this.state.tab === 1 ? "hand active" : "hand"}><a onClick={e => this.setState({ tab: 1 })} data-toggle="tab" target="_self" aria-expanded="false">آدرس</a></li>
                                {/*<li role="presentation" className={this.state.tab === 2 ? "hand active" : "hand"} ><a onClick={e => this.setState({ tab: 2 })} data-toggle="tab" target="_self" aria-expanded="false">حسابهای بانکی</a></li>*/}
                            </ul>
                            <div className="tab-content">
                                <div className={"tab-pane fade in " + (this.state.tab === 0 ? "active" : "")}>
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <label className="title1">نوع شخص</label>
                                            <select defaultValue={this.state.data.record.type} onChange={e => this.state.data.record.type = parseInt(e.target.value)} className="form-control input-sm">
                                                <option value='1'>حقیقی</option>
                                                <option value='2'>حقوقی</option>
                                            </select>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label className="title1">نام <span className="red">*</span></label>
                                                <input autocomplete="off" defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} onkeypress="return isCharacterKey(event)" type="text" className="form-control input-sm" maxlength="100" />
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <label className="title1">کد <span className="red">*</span></label>
                                                <input autocomplete="off" defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = parseInt(e.target.value)} onkeypress="return isCharacterKey(event)" type="text" className="form-control input-sm" maxlength="100" />
                                            </div>
                                        </div>
                                    </div >
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <label for="inputNationalCode" className="title1">کد/شناسه ملی </label>
                                                <input defaultValue={this.state.data.record.nationalId} onChange={e => this.state.data.record.nationalId = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="14" />
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <label for="inputNationalCode" className="title1">کد اقتصادی </label>
                                                <input defaultValue={this.state.data.record.codeEgtesadi} onChange={e => this.state.data.record.codeEgtesadi = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="12" />
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <label for="inputNationalCode" className="title1">شماره ثبت </label>
                                                <input defaultValue={this.state.data.record.shomareSabt} onChange={e => this.state.data.record.shomareSabt = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="10" />
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div className="row">*/}
                                    {/*    <div className="col-sm-4">*/}
                                    {/*        <label className="title1">مشتری</label>*/}
                                    {/*        <select defaultValue={this.state.data.record.isCustomer ? "1" : "0"} onChange={e => this.state.data.record.isCustomer = e.target.value === "1"} className="form-control input-sm">*/}
                                    {/*            <option value='1'>بله</option>*/}
                                    {/*            <option value='0'>خیر</option>*/}
                                    {/*        </select>*/}
                                    {/*    </div>*/}
                                    {/*    <div className="col-sm-3">*/}
                                    {/*        <div className="form-group">*/}
                                    {/*            <label for="inputNationalCode" className="title1">مانده ابتدای دوره</label>*/}
                                    {/*            <input defaultValue={this.state.data.record.customerFirstAnnualRemain} onChange={e => this.state.data.record.customerFirstAnnualRemain = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="10" />*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*    <div className="col-sm-4">*/}
                                    {/*        <label className="title1">نوع</label>*/}
                                    {/*        <select defaultValue={this.state.data.record.customerFirstAnnualRemainType} onChange={e => this.state.data.record.customerFirstAnnualRemainType = parseInt(e.target.value)} className="form-control input-sm">*/}
                                    {/*            <option value='0'>خنثی</option>*/}
                                    {/*            <option value='1'>بدهکار</option>*/}
                                    {/*            <option value='2'>بستانکار</option>*/}
                                    {/*        </select>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    {/*<div className="row">*/}
                                    {/*    <div className="col-sm-4">*/}
                                    {/*        <label className="title1">تامین کننده</label>*/}
                                    {/*        <select defaultValue={this.state.data.record.isSupplier ? "1" : "0"} onChange={e => this.state.data.record.isSupplier = e.target.value === "1"} className="form-control input-sm">*/}
                                    {/*            <option value='1'>بله</option>*/}
                                    {/*            <option value='0'>خیر</option>*/}
                                    {/*        </select>*/}
                                    {/*    </div>*/}
                                    {/*    <div className="col-sm-3">*/}
                                    {/*        <div className="form-group">*/}
                                    {/*            <label for="inputNationalCode" className="title1">مانده ابتدای دوره</label>*/}
                                    {/*            <input defaultValue={this.state.data.record.supplierFirstAnnualRemain} onChange={e => this.state.data.record.supplierFirstAnnualRemain = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="10" />*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*    <div className="col-sm-4">*/}
                                    {/*        <label className="title1">نوع</label>*/}
                                    {/*        <select defaultValue={this.state.data.record.supplierFirstAnnualRemainType} onChange={e => this.state.data.record.supplierFirstAnnualRemainType = parseInt(e.target.value)} className="form-control input-sm">*/}
                                    {/*            <option value='0'>خنثی</option>*/}
                                    {/*            <option value='1'>بدهکار</option>*/}
                                    {/*            <option value='2'>بستانکار</option>*/}
                                    {/*        </select>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <label className="title1">گروه </label>
                                                <SelectAsync
                                                    value={this.state.data.record.groupId != this.defaultGuid() ? [{ value: this.state.data.record.groupId, label: this.state.data.record.groupName }] : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب گروه"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadConstantsOptions(inputValue, callback,1, 1)}
                                                    onChange={e => this.setGroup(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"tab-pane fade in " + (this.state.tab === 1 ? "active" : "")}>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="panel">
                                                <div className="panel-body">
                                                    <div className="row form-group">
                                                        <label for="inputState" className="title1 col-sm-2 control-label text-left">استان </label>
                                                        <div className="col-sm-4">
                                                            <select defaultValue={this.state.data.record.ostan} onChange={e => this.state.data.record.ostan = e.target.value} className="form-control input-sm">
                                                                <option value="">انتخاب کنید</option>
                                                            </select>
                                                        </div>
                                                        <label for="inputCity" className="title1 col-sm-2 control-label text-left">شهر </label>
                                                        <div className="col-sm-4">
                                                            <input defaultValue={this.state.data.record.city} onChange={e => this.state.data.record.city = e.target.value} autocomplete="off" type="text" className="form-control input-sm" onkeydown="preventNumberInput(event)" maxlength="50" />
                                                        </div>
                                                    </div>
                                                    <div className="row form-group">
                                                        <label for="inputPostalCode" className="title1 col-sm-2 control-label text-left">کدپستی </label>
                                                        <div className="col-sm-4">
                                                            <input defaultValue={this.state.data.record.postalCode} onChange={e => this.state.data.record.postalCode = e.target.value} autocomplete="off" type="text" className="form-control input-sm" id="inputPostalCode" maxlength="10" />
                                                        </div>
                                                        <label for="inputContactEmail" className="title1 col-sm-2 control-label text-left">ایمیل </label>
                                                        <div className="col-sm-4">
                                                            <input defaultValue={this.state.data.record.email} onChange={e => this.state.data.record.email = e.target.value} autocomplete="off" type="text" className="form-control input-sm" id="inputContactEmail" maxlength="100" />
                                                        </div>
                                                    </div>
                                                    <div className="row form-group">
                                                        <label for="inputPhone" className="title1 col-sm-2 control-label text-left">تلفن </label>
                                                        <div className="col-sm-4">
                                                            <input defaultValue={this.state.data.record.city} onChange={e => this.state.data.record.city = e.target.value} autocomplete="off" type="text" className="form-control input-sm" id="inputPhone" maxlength="20" />
                                                        </div>
                                                        <label id="mobileField1" for="inputPhone" className="title1 col-sm-2 control-label text-left">موبایل </label>
                                                        <div id="mobileField2" className="col-sm-4">
                                                            <input defaultValue={this.state.data.record.phone} onChange={e => this.state.data.record.phone = e.target.value} autocomplete="off" type="text" className="form-control input-sm" id="inputMobile" maxlength="11" />
                                                        </div>
                                                    </div>
                                                    <div className="row form-group">
                                                        <label for="inputFax" className="title1 col-sm-2 control-label text-left">فکس </label>
                                                        <div className="col-sm-4">
                                                            <input defaultValue={this.state.data.record.fax} onChange={e => this.state.data.record.fax = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="20" />
                                                        </div>
                                                        <label for="inputPhone" className="title1 col-sm-2 control-label text-left">وبسایت </label>
                                                        <div className="col-sm-4">
                                                            <input defaultValue={this.state.data.record.website} onChange={e => this.state.data.record.website = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="150" />
                                                        </div>
                                                    </div>
                                                    <div className="row form-group">
                                                        <label for="inputAddress" className="title1 col-sm-2 control-label text-left">آدرس </label>
                                                        <div className="col-sm-10">
                                                            <textarea defaultValue={this.state.data.record.address} onChange={e => this.state.data.record.address = e.target.value} className="form-control input-sm ng-pristine ng-untouched" rows="2" maxlength="200"></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="row form-group">
                                                        <label for="inputAddress" className="title1 col-sm-2 control-label text-left">یادداشت </label>
                                                        <div className="col-sm-10">
                                                            <textarea defaultValue={this.state.data.record.note} onChange={e => this.state.data.record.note = e.target.value} className="form-control input-sm ng-pristine ng-untouched" rows="2" maxlength="200"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"tab-pane fade in " + (this.state.tab === 2 ? "active" : "")}>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="panel">
                                                <div className="panel-body" style={{ "padding-right": "0", "padding-left": "0" }}>
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr className="active" style={{ "font-size": "9pt", "font-weight": "bold" }}>
                                                                <td>نام بانک</td>
                                                                <td>شماره حساب</td>
                                                                <td>شماره شبا</td>
                                                                <td>شماره کارت</td>
                                                                <td></td>
                                                            </tr>
                                                        </thead>
                                                        <tbody></tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke hand" onClick={e => this.closeMe()}>انصراف</button>
                            <a name="person_forma_modal_create" onClick={e => this.save(e)} className="btn btn-success">ذخیره</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}